// extracted by mini-css-extract-plugin
export default {"infoButton":"style_infoButton__j9U6F","infoIcon":"style_infoIcon__jqlqq"};